import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { httpRequest } from '~/adapters/httpRequest';
import { host } from '~/config/settings/worktango.settings';
import { statuses } from '~/config/settings/notification.settings';
import { defaultLang } from '~/config/settings/app.settings';
import * as languages from '../languages';
import * as transformers from '../transformers';
import * as schemas from '../schemas';
import { fetchCompanySurveyTypesQuery } from '../react-query/surveyTypes';

const fetchSurveyTypesWithCategories = createAsyncThunk(
  'survey-type/fetchSurveyTypesWithCategories',
  // @ts-expect-error TS(2339): Property 'companyId' does not exist on type 'void'... Remove this comment to see the full error message
  async ({ companyId, lang = defaultLang }) => {
    const surveyTypeList = await fetchCompanySurveyTypesQuery({ companyId, lang });
    const normalizedData = normalize(surveyTypeList, [schemas.surveyType]);

    return normalizedData;
  },
);

const createSurveyType = createAsyncThunk(
  'survey-type/createSurveyType',
  // @ts-expect-error TS(2339): Property 'companyId' does not exist on type 'void'... Remove this comment to see the full error message
  async ({ companyId, baseSurveyTypeId = null, threshold, translations }, { rejectWithValue, getState }) => {
    const state = getState();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const languageCodeIds = state.entities.languages.codeIds;
    const names = transformers.surveyTypeTranslationsToNames(translations, languageCodeIds);
    const url = `${host}/survey-types`;
    const res = await httpRequest(url, {
      method: 'POST',
      body: {
        companyId,
        names,
        threshold,
        baseSurveyTypeId,
      },
    });

    if (res.error) return rejectWithValue(res.error);

    const surveyType = transformers.surveyTypeFrom(res?.payload?.surveyType);
    const normalizedData = normalize(surveyType, schemas.surveyType);

    return {
      ...normalizedData,
      notification: {
        title: languages.t('notifications.title.done'),
        message: languages.t('notifications.message.surveyTypeCreated'),
        status: statuses.success,
      },
    };
  },
);

const updateSurveyType = createAsyncThunk(
  'survey-type/updateSurveyType',
  async (
    // @ts-expect-error TS(2339): Property 'surveyTypeId' does not exist on type 'vo... Remove this comment to see the full error message
    { surveyTypeId, baseSurveyTypeId, companyId, threshold, translations },
    { rejectWithValue, getState },
  ) => {
    const state = getState();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const languageCodeIds = state.entities.languages.codeIds;
    const names = transformers.surveyTypeTranslationsToNames(translations, languageCodeIds);
    const url = `${host}/survey-types/${surveyTypeId}`;
    const res = await httpRequest(url, {
      method: 'PATCH',
      body: {
        companyId,
        names,
        threshold,
        baseSurveyTypeId,
      },
    });

    if (res.error) return rejectWithValue(res.error);

    const surveyType = transformers.surveyTypeFrom(res?.payload?.surveyType);
    const normalizedData = normalize(surveyType, schemas.surveyType);

    return {
      ...normalizedData,
      notification: {
        title: languages.t('notifications.title.done'),
        message: languages.t('notifications.message.surveyTypeUpdated'),
        status: statuses.success,
      },
    };
  },
);

export const surveyTypeActions = {
  fetchSurveyTypesWithCategories,
  createSurveyType,
  updateSurveyType,
};
